import React from 'react';
import {AppBar, Button, Toolbar, Typography, withStyles} from "material-ui";
import {Link} from "react-router-dom";
import {connect} from "react-redux";

export class Header extends React.Component {

    state = {
        isLogin: false,
    };

    componentDidMount = () => {
        if (JSON.stringify(this.props.currentUser) !== JSON.stringify({}) && !this.state.isLogin) {
            this.setState({isLogin: true});
        }

        if (JSON.stringify(this.props.currentUser) === JSON.stringify({}) && this.state.isLogin) {
            this.setState({isLogin: false});
        }
    };

    componentDidUpdate = () => {
        if (JSON.stringify(this.props.currentUser) !== JSON.stringify({}) && !this.state.isLogin) {
            this.setState({isLogin: true});
        }

        if (JSON.stringify(this.props.currentUser) === JSON.stringify({}) && this.state.isLogin) {
            this.setState({isLogin: false});
        }
    };

    render() {
        const {classes, currentUser} = this.props;
        const {isLogin} = this.state;

        return (
            <div className={classes.root}>
                <AppBar position="fixed">
                    <Toolbar>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            三島事務所
                        </Typography>

                        {!isLogin ? <Button color="inherit" component={Link} to="/">ログイン</Button> : null}

                        {isLogin ? <Button color="inherit">{currentUser.name}</Button> : null}
                        {isLogin ? <Button color="inherit" component={Link} to="/dashboard">ダッシュボード</Button> : null}
                        {isLogin ? <Button color="inherit" component={Link} to="/">ログアウト</Button> : null}
                    </Toolbar>
                </AppBar>
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginBottom: 60,
    },
    flex: {
        flex: 1,
    },
});

Header = withStyles(styles)(Header);
Header = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser,
        }
    }
)(Header);


// WEBPACK FOOTER //
// ./src/components/header/index.js